<template>
    <path :style="{ fill: color }" d="M78.7,65c-1.2-7.5,3.7-17.4,3.4-25.1c-0.2-7.7-3.3-15.5-6.3-21c-3-5.4-5.6-7-7.8-8.1
	c-1.6-0.8-3.6-1.4-5.3-1.8c0,0,0,0,0,0c-2-0.5-3.6-0.6-3.6-0.6s-3.2-4.1-7.6-4.5C47,3.4,38.6,8.4,33.6,15.3c-5,6.9-9,14-9.6,20.7
	c-0.6,6.7,3.7,18.5,3.7,25.3s-6.1,9.5-8.1,14.7c-1.7,4.4-1.4,8-1.2,8.9c4.3-2.5,9.2-4.3,13-5.5c2.5-0.8,4.5-1.5,5.5-1.8
	c0.4-0.2,0.7-0.2,0.7-0.2l3.3-1.1c0.8-0.3,1.3-1,1.3-1.9v-5.8c-2.5-2.7-4.5-5.7-5.7-8.1c-0.8-1.7-1.5-4.1-2-7
	c-0.3,0.3-0.7,0.5-1.1,0.5c-1.7,0-2.3-1.8-3.4-4.1c-1.1-2.3-2.3-5.1-1.6-6.7c0.9-2.6,3.1-2.4,4.6-1.5c0.8,2.5,1.7,4.3,1.7,4.3
	c0-1.4-0.4-7,0-10.6c0.4-3.7,4.6-6.6,7.6-7c3-0.4,5.3,0.5,9.6-0.1c4.3-0.6,8.6-5,10.1-5.2c1.5-0.2,8.6,4.8,10.1,8.9
	c1.6,4.1,1.9,14.6,1.9,14.6s0.6-2.2,1.3-5.1c1.5-0.6,3.2-0.5,4.1,1.8c0.6,1.7-0.5,4.4-1.6,6.7c-1.1,2.3-1.7,4.1-3.4,4.1
	c-0.3,0-0.5-0.1-0.7-0.2c-0.3,2-0.7,3.7-1,5c-0.2,0.7-0.5,1.5-0.9,2.3c0,0,0,0,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6
	c0,0.1-0.1,0.1-0.1,0.2C71,61.9,71,62,70.9,62.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1-0.1,0.1-0.1,0.2
	c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4
	c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3
	c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.3,0.3-0.4,0.4
	c-0.1,0.1-0.2,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1v5.5c0,0.8,0.5,1.6,1.3,1.9l3.3,1.1c0,0,0.3,0.1,0.7,0.2c1,0.3,3,1,5.5,1.8
	c3.3,1.1,7.4,2.5,11.3,4.5C87.2,76.6,79.6,70.9,78.7,65z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair14',
        mixins: [Hair],
    }
</script>

